import axios from "axios";

export async function userGroupInfo(user) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "user_group_info.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    // Prod
    if (user) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                id_person: user.id,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function userGroupCreate(group, member) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "user_group_create.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    // Prod
    if (group) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                id_group_type: group.type,
                id_person_1: group.ownerId,
                id_person_2: member.id,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function userGroupAdd(group, member) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "user_group_add.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    // Prod
    if (group) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                id_group: group.id,
                id_person_1: group.ownerId,
                id_person_2: member.id,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function userGroupRemove(group, member) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "user_group_remove.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    // Prod
    if (group) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                id_group: group.id,
                id_person_1: group.ownerId,
                id_person_2: member.id,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}

export async function getThem(group) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    // const port = process.env.VUE_APP_API_PORT || "";
    const route = "get_them.php";

    const method = "POST";

    const apiUsername = process.env.VUE_APP_API_USERNAME;
    const apiPassword = process.env.VUE_APP_API_PASSWORD;

    // Prod
    if (group) {
        return axios({
            method: method,
            url: `${baseUrl}/${route}`,
            auth: {
                username: apiUsername,
                password: apiPassword
            },
            data: JSON.stringify({
                "id_group": group.id,
            })
        }).then(res => {
            return res;
        }).catch(e => {
            if (e.response) {
                return e.response;
            }
            return false;
        });
    }
}